<template>
  <div class="relative-index">
    <div class="container h-100">
      <div class="all-landing h-100">
        <div class="row h-100">
          <div class="col-md-6 col-12">
            <div class="landing-all-right h-100">
              <div class="landing-right">
                <h1 class="landing-join color-main mb-3">{{ $t('nav.siteName')  }}</h1>
                <h2 class="landing-join2 mb-3">{{ $t('landingComp.designedToSimplify') }}</h2>
                <p class="mb-4">
                  {{ introSite.intro_about }}
                </p>
                <div class="downloads">
                  <a target="_blank" :href="introSite.android_app_link">
                    <img :src="googleImg" alt="" />
                  </a>
                  <a target="_blank" :href="introSite.ios_app_link">
                    <img :src="appleImg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="landing-left text-center h-100">
              <!--introSite.logo-->
              <img :src="mobileImg" :class="{ animateMe: loaded }" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref , defineProps } from "vue";
// reactive states
const mobileImg = ref(require("../../assets/imgs/Group 179132.png"));
const googleImg = ref(require("../../assets/imgs/Group 4461.png"));
const appleImg = ref(require("../../assets/imgs/Group 4460.png"));
const loaded = ref(false);


// props
const props = defineProps(["introSite"]);

// functions


// mounted
onMounted(() => {
  loaded.value = true;
  console.log(props);
});
</script>
